<template>
  <div class="condition">
    <div class="condition-wrapper">
      <div v-if="isClock" class="condition-title">
        <h2>Zustand der Uhr</h2>
      </div>
      <div v-else-if="isJewelry" class="condition-title">
        <h2>Nähere Angaben zu Ihrem Schmuckstück</h2>
      </div>
      <div v-else class="condition-title">
        <h2>Zustand der Uhr</h2>
      </div>
          <div class="condition-content">
            <div class="content-wrapper">
        <div class="text-align-center condition-content-wrapper">
        <div class="condition-intro" v-if="isClock">
          Laden Sie bitte zwei bis drei Bilder Ihrer Uhr mit jeweils der Vorder-
          und Rückseite hoch.<br />
          Die Schadenstelle oder der Defekt sollte ebenfalls gut erkennbar sein.
        </div>
        <div class="condition-intro" v-else-if="isJewelry">
          Laden Sie bitte zwei bis drei Bilder Ihres Schmuckstücks mit jeweils der
          Vorder- und Rückseite hoch.<br />
          Das einzureichende Schmuckstück sowie der Defekt (sofern einer vorliegt) sollten hierbei gut erkennbar sein.
        </div>
        <div class="image-upload-wrapper">
          <input
            id="images"
            ref="images"
            type="file"
            accept="image/*"
            style="opacity: 0;"
            multiple
            @change="upload"
          />
           <label for="images" class="image-input" style="width: 100% !important">
              <span>Foto hochladen</span>
              <span>
                <img src="@/assets/images/upload-plus.svg" alt="upload-plus" />
              </span>
            </label>
        </div>
        <div class="condition-bottom-info">
          <p class="small">
            Laden Sie eine .png oder .jpg Datei hoch. Maximal 5MB
          </p>
        </div>
        <div v-if="hasError('images')" class="invalid-feedback">
          <div class="error">
            Bitte fügen Sie mind. zwei jedoch nicht mehr als drei Fotos hinzu.
          </div>
        </div>
        <div v-if="sizeError" class="invalid-feedback">
          <div class="error">
            Bitte laden Sie Bilder mit maximal 5MB hoch.
          </div>
        </div>
        <div class="form-preview-images">
          <div
            v-for="(image, index) in formData.images"
            :key="index"
            class="mr-3 mt-3"
          >
            <img :src="image.preview" class="img-fluid mh-100" />
            <button type="button" class="btn btn-primary" @click="remove(index)" style="background: transparent">
              <img src="@/assets/images/icon-delete.svg" />
            </button>
          </div>
        </div>
        <div class="condition-description" v-if="conditionDescription !== undefined">
          <float-label>
            <textarea
            id="conditionDesc"
            class="form-control"
            v-model="conditionDescription"
            rows="4"
            placeholder="Schildern Sie bitte den Schaden."
            v-if="isClock"
          ></textarea>
          </float-label>
          <float-label>
            <textarea
            id="conditionDesc"
            class="form-control"
            v-model="conditionDescription"
            rows="4"
            placeholder="Angaben zu Ihren Wünschen (z.B. Ringweite, Ketten-/Armbandlänge, Anzahl zu ersetzender Steine usw.)"
            v-if="isJewelry"
          ></textarea>
          </float-label>
        </div>
        </div>

      </div>
      </div>

    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";

const minAndMaxItems = value => value.length > 1 && value.length < 4;

export default {
  name: "ConditionalCheck",
  validations: {
    formData: {
      images: { required, minAndMaxItems }
    }
  },
  data() {
    return{
      sizeError: false,
    }
  },
  computed: {
    formData: {
      get() {
        return this.$store.state.checkoutFormData;
      },
      set(value) {
        this.$store.commit("updateCheckoutFormData", value);
      }
    },
    isJewelry() {
      return this.$store.getters.isJewelry;
    },
    isClock() {
      return this.$store.getters.isClock;
    },
    conditionDescription: {
      get() {
        return this.$store.state.conditionDescription;
      },
      set(value) {
        this.$store.commit("setConditionDescription", value);
      }
    }
  },
  mounted() {
    this.$store.commit("setValidation", this.$v);
  },
  methods: {
    upload(event) {
      for (const image of event.target.files) {
        try {
          if (image.type.includes("image/png") ||
          image.type.includes("image/jpeg") ||
          image.type.includes("image/gif") ||
          image.name.includes("image/heic") ||
          image.type.includes("image/webp") ||
          image.name.includes("image/heif")) {
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
              image.preview = e.target.result;
              if(image.size < 5243000){
                this.sizeError = false;
                this.formData.images.push(image);
              } else{
                this.sizeError = true;
              }
            };
          }
        } catch(error){
          console.log(error);
        }
      }
    },
    remove(index) {
      this.formData.images.splice(index, 1);
      this.$refs.images.value = null;
    },
    hasError(fieldName) {
      return (
        fieldName in this.$v.formData && this.$v.formData[fieldName].$error
      );
    }
  }
};
</script>
